interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="59"
    height="50"
    viewBox="0 0 59 50"
    fill="none"
  >
    <g clipPath="url(#clip0_486_11601)">
      <path
        d="M46.6815 0.859697H55.8975V10.0757"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0014 49.1403H2.7854V39.9072"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.8975 39.9072V49.1403H46.6815"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.7854 10.0757V0.859697H12.0014"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5984 25C20.5984 29.8315 24.5186 33.7517 29.3501 33.7517C34.1816 33.7517 38.1018 29.8315 38.1018 25C38.1018 20.1685 34.1816 16.2483 29.3501 16.2483C24.5186 16.2483 20.5984 20.1685 20.5984 25Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.5179 33.511C45.0138 31.0179 45.8735 28.1121 45.8735 25C45.8735 21.8879 44.9622 18.793 43.3804 16.2655"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0964 16.6094C13.6521 19.0681 12.8096 21.9395 12.8096 25C12.8096 27.8542 13.5317 30.5365 14.8041 32.8748"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3501 8.47661C29.3501 8.47661 45.0654 7.70289 57.8405 25C45.0654 42.2971 29.3501 41.5234 29.3501 41.5234C29.3501 41.5234 13.6348 42.2971 0.859741 25C13.6348 7.70289 29.3501 8.47661 29.3501 8.47661Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1368 49.1403H41.3514"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1368 0.859697H41.3514"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_486_11601">
        <rect width="58.6829" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
